jQuery(document).ready(function() {
  var tables = jQuery('.node__content table');
  tables.each(function() {
    jQuery(this).flextable({
      debug: true,
      bt: 'parent',
      bw: 991,
      cm: 'load',
      // hparent: '',
      // hcell: '',
      // header: 'before',
      combine: true
    });
  });
});

